import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

/**
 * Returns the discount of a product, formatted as a string.
 *
 * @param product - The GkAirRecommendedProductDataWeb to get the discount for.
 *
 * @example
 * const discount = gkAirAccessorGetProductDiscount(product)
 * @returns The discount as a string e.g "−20%", or undefined if the product is not discounted.
 */
export const gkAirAccessorGetProductDiscount = (
  product: GkAirRecommendedProductDataWeb,
): string | undefined => {
  return product.reduced === 'true'
    ? `−${Number(product.discount_in_percent)}%`
    : undefined
}
